import script from "./ProcessTreeViewer.ts?vue&type=script&lang=ts"
export * from "./ProcessTreeViewer.ts?vue&type=script&lang=ts"

import "./ProcessTreeViewer.scss?vue&type=style&index=0&id=cf97943e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf97943e"]])

export default __exports__